import { createRouter, createWebHashHistory } from 'vue-router'

import Main from '~/layout/index.vue'
import Login from '~/views/login/login.vue'
import NotFound from '~/views/404.vue'

// 默认路由，所有用户共享
const routes = [{
  path: '/',
  name: 'main',
  component: Main,
  children: [{
    path: '/noticInfoManage',
    name: '/noticInfoManage',
    meta: { title: '通知管理' },
    component: () => import('~/views/sysSetting/noticInfoManage.vue')
  }]
}, {
  path: '/login',
  component: Login,
  meta: { title: '登录' }
}, {
  path: '/:pathMatch(.*)',
  name: 'NotFound',
  component: NotFound,
  meta: { title: '页面丢失了' }
}]

// 动态路由
const asyncRouters = [
  // {
  //   path: '/',
  //   name: '/',
  //   meta: { title: '首页' },
  //   component: () => import('~/views/index.vue')
  // },
  {
    path: '/',
    name: '/',
    meta: { title: '文档中心' },
    component: () => import('~/views/documentCenter/documentCenter.vue')
  },
  {
  path: '/userManage',
  name: '/userManage',
  meta: { title: '用户管理' },
  component: () => import('~/views/sysSetting/userManage.vue')
  },
  {
  path: '/menuManage',
  name: '/menuManage',
  meta: { title: '菜单管理' },
  component: () => import('~/views/sysSetting/menuManage.vue')
  },
  {
    path: '/documentCenter',
    name: '/documentCenter',
    meta: { title: '文档中心' },
    component: () => import('~/views/documentCenter/documentCenter.vue')
  },
  {
  path: '/roleManage',
  name: '/roleManage',
  meta: { title: '权限管理' },
  component: () => import('~/views/sysSetting/roleManage.vue')
  },
  {
  path: '/dictManage',
  name: '/dictManage',
  meta: { title: '数据字典管理' },
  component: () => import('~/views/sysSetting/dictInfoManage.vue')
  },
  {
  path: '/noticInfoManage',
  name: '/noticInfoManage',
  meta: { title: '通知管理' },
  component: () => import('~/views/sysSetting/noticInfoManage.vue')
  },
  {
  path: '/dealerBelongManage',
  name: '/dealerBelongManage',
  meta: { title: '经销商归属管理' },
  component: () => import('~/views/sysSetting/dealerBelongManage.vue')
  },
  {
    path: '/dealerManage',
    name: '/dealerManage',
    meta: { title: '经销商列表' },
    component: () => import('~/views/sysSetting/dealerManage.vue')
  },
  {
  path: '/AuditReportManagement',
  name:'/AuditReportManagement',
  meta: {title: '咨询报告文件管理', keepAlive: true},
  component: () => import('~/views/dealerDataManagement/index.vue')
  },
  {
  path: '/dealerAuditReport',
  name:'/dealerAuditReport',
  meta: {title: '经销商咨询报告管理', keepAlive: true},
  component: () => import('~/views/dealer/dealerAuditReport.vue')
  },
  {
    path: '/dealerBasicInformation',
    name: '/dealerBasicInformation',
    meta: { title: '经销商信息维护' },
    component: () => import('~/views/dealer/BasicInformation.vue')
  },
  {
    path: '/projectManager',
    name: '/projectManager',
    meta: { title: '项目管理' },
    component: () => import('~/views/Consultants/projectManager.vue')
  }
]

export const router = createRouter({
  history: createWebHashHistory(),
  routes
})

// 动态添加路由
export function addRoutes(menus) {
  // 是否有新的路由
  let hasNewRoutes = false
  const findAndAddRoutesByMenus = (arr) => {
    arr.forEach(e => {
      let item = asyncRouters.find(o => o.path == e.menuUrl)
      if (item && !router.hasRoute(item.path)) {
        router.addRoute('main', item)
        hasNewRoutes = true
      }
      if (e.childMenus && e.childMenus.length > 0) {
        findAndAddRoutesByMenus(e.childMenus)
      }
    })
  }
  findAndAddRoutesByMenus(menus)
  return hasNewRoutes
}
